module.exports = __webpack_public_path__ + "img/68.ff44fdaf.jpg";